/* DEVICE ROUTE */
export const DEVICE_ROUTE = '/devices'
export const DEVICE_ROUTES = {
    baseUrl: DEVICE_ROUTE,
    createUrl: `${DEVICE_ROUTE}/create`,
    detailUrl: `${DEVICE_ROUTE}/:id`,
    buildUrl: (deviceId: number) => `${DEVICE_ROUTE}/${deviceId}`
}

/* EVENTS ROUTES */
export const EVENTS_ROUTE = '/sites'
export const EVENTS_ROUTES = {
    baseUrl: EVENTS_ROUTE,
    createUrl: `${EVENTS_ROUTE}/create`,
    detailUrl: `${EVENTS_ROUTE}/:id`,
    buildUrl: (siteId: number) => `${EVENTS_ROUTE}/${siteId}`
}

export const CHECKPOINT_ROUTE = '/pois'
export const EVENT_CHECKPOINT_ROUTES = {
    baseUrl: `${EVENTS_ROUTES.detailUrl}${CHECKPOINT_ROUTE}`,
    detailUrl: `${EVENTS_ROUTES.detailUrl}${CHECKPOINT_ROUTE}`,
    createUrl: `${EVENTS_ROUTES.detailUrl}${CHECKPOINT_ROUTE}/create`,
    buildUrl: (id: number) => `${EVENTS_ROUTES.buildUrl(id)}${CHECKPOINT_ROUTE}`
}

export const DETECTION_ROUTE = '/detections'
export const PRESENCE_ROUTE = '/presences'
export const TRIPS_ROUTE = '/trips'
export const TRIPS_SHUTTLES_ROUTE = '/trips/shuttles'
export const TRIPS_PERSONS_ROUTE = '/trips/persons'

/* ACCOUNT ROUTES */
export const MY_ACCOUNT_ROUTE = '/myAccount'

/* GUEST ROUTES */
export const GUEST_ROUTE = '/guest'
export const CREATE_PASSWORD_ROUTE = `${GUEST_ROUTE}/create_password`
export const FORGOT_PASSWORD_ROUTE = `${GUEST_ROUTE}/forgot_password`
export const SEND_LINK_PWD_ROUTE = `${GUEST_ROUTE}/sent_link`
export const RESET_PASSWORD_ROUTE = `${GUEST_ROUTE}/reset_password`
export const ONBOARDING_ROUTE = '/onboarding'

export const SUPPORTFAQ_ROUTE = '/support-faq'
